import {
    FETCH_GETDOCTORCV_FULFILLED,
    FETCH_GETDOCTORCV_REJECTED,
    FETCH_GETDOCTORCV_PENDING,
    RESET,
  } from "../../actions/application/getDoctorCv";
  const initialState = {
    done: false,
    error: false,
  };
  
  export default (state = initialState, action) => {
  
    switch (action.type) {
  
      case FETCH_GETDOCTORCV_PENDING:
        return {
          done: false,
          error: false,
        };
      case FETCH_GETDOCTORCV_FULFILLED:
        return {
          ...state,
          careProviders: action.payload,
          done: true,
          error: false,
        };
      case FETCH_GETDOCTORCV_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
        };
      case RESET:
        return {
          initialState,
          done: false,
          error: false,
        };
      default:
        return state;
    }
  };